import { InputText } from 'primereact/inputtext';
import React from 'react';
import './styleTemplate.css';

export const urlTemplate = rowData => <InputText tooltipOptions={{ className: 'p-tooltip' }} tooltip={rowData.url} style={{ width: '100%' }}  type={'url'} maxLength={30} value={rowData.url}/>;
export const statusTemplate = rowData => <span style={{ display: 'block' }}>{rowData.status ? 'Ativo': 'Inativo'}</span>;
export const vincularGrupoTemplate = rowData => <span style={{ display: 'block' }}>{rowData.status ? 'Ativo': 'Inativo'}</span>;